import 'regenerator-runtime/runtime'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { LicenseManager } from 'ag-grid-enterprise'
import { AG_GRID_KEY, SENTRY_CONFIG, SYNCFUSION_LICENSE_KEY } from './config'
import * as Sentry from '@sentry/browser'
import { HistoryRouter as Router } from 'redux-first-history/rr6'
import { registerLicense } from '@syncfusion/ej2-base'

import { store, sagaMiddleware, history } from './configureStore'
import rootSaga from './rootSaga'

import App from 'components/App/App.js'

import '!style-loader!css-loader!react-day-picker/dist/style.css' // eslint-disable-line

import '!style-loader!css-loader!styles/overrides/react-select.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/react-trello.css' // eslint-disable-line
import '!style-loader!css-loader!bootstrap/dist/css/bootstrap.min.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/css-resetter.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/markdown.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/google-autocomplete.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/material-table.css' // eslint-disable-line

sagaMiddleware.run(rootSaga)

LicenseManager.setLicenseKey(AG_GRID_KEY)
registerLicense(SYNCFUSION_LICENSE_KEY)

if (process.env.NODE_ENV === 'production') {
  Sentry.init(SENTRY_CONFIG)
}

const rootEl = document.getElementById('app')
const root = createRoot(rootEl)

const renderApp = Component => {
  root.render(
    <Provider store={store}>
      <Router history={history}>
        <Component />
      </Router>
    </Provider>
  )
}

renderApp(App)
